import React from 'react';
import { PropTypes } from 'prop-types';
import { observer } from 'mobx-react';
import { DownloadLink } from '../link/download-link';
import { AppDetailInfoContentRow } from '../app-detail/app-detail-info-content-row.jsx'
import { utilsService } from '../../core/services/utils.service';

@observer
export class NewAppReview extends React.Component {

  static propTypes = {
    masterStore: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.masterStore = this.props.masterStore;
    this.newAppMasterStore = this.masterStore.newAppMasterStore;
    this.newAppDetailsStore = this.newAppMasterStore.newAppDetailsStore;
    this.newAppData = this.newAppMasterStore.newAppData;
    this.downloadChecklist = this.masterStore.downloadDeveloperChecklistFile.bind(this.masterStore);
  }

  renderAppIcon = () => {
    if (this.newAppMasterStore.newAppData.iconImageURLAndDescription) {
      return <AppDetailInfoContentRow title="High-resolution icon" content={(<div className="app-icon">
        <img alt="appIcon" src={this.newAppMasterStore.newAppData.iconImageURLAndDescription} />
      </div>)} />
    }
    return '';
  };

  renderScreenShots = (title, screenshots) => {
    return (<div className="app-info-text-content row">
      <div className="title col-3">
        {`${title === 'phone' ? 'Mobile' : 'Tablet'} Screenshots:`}
      </div>
      <div className="content col-9">
        <div className="app-info-screenshots">
          {
            screenshots.map((screenshot, index) => {
              return (<div key={index} className={`app-info-screenshot ${title}`}>
                <img src={screenshot.imageURL} alt={`${title} screenshot ${index + 1}`} />
                <small className="screenshot-description">
                  <span className="sr-only">{`Description for screenshot ${index + 1}: `}</span>
                  {screenshot.description}
                </small>
              </div>);
            })
          }
        </div>
      </div>
    </div>);
  };

  renderCertificateDownloadField = () => {
    return (<DownloadLink
      title={this.newAppData.caFormFileName}
      onClick={this.downloadChecklist}
      srText="Download current file"
      smallText={this.newAppData.caFormUploadDate
        ? `Uploaded ${utilsService.normalizedDate(this.newAppData.caFormUploadDate, 'MMMM Do YYYY | h:mm:ss a')}`
        : ''} />)
  }

  renderAppFileField = () => {
    return (<div>
      {this.newAppData.appFileName}
      <small>Uploaded {utilsService.normalizedDate(this.newAppData.fileUploadDateTime, 'MMMM Do YYYY | h:mm:ss a')}</small>
    </div>)
  }

  render() {
    let appType = this.newAppData.app_type;
    if (/CERTIFIED/i.test(appType)) {
      appType = 'FirstNet Certified';
    } else if (/GENERAL/i.test(appType)) {
      appType = 'FirstNet Verified';
    }
    const mobileScreenshots = this.newAppData.mobileURLAndDescription;
    const tabletScreenshots = this.newAppData.tabletURLAndDescription;
    return (<div className="new-app-review">
      <div className="container">
        <h2>Review Submission</h2>
        <section className="review-section">
          <AppDetailInfoContentRow title="App approval type" content={appType} />
          <AppDetailInfoContentRow title="App checklist" content={this.renderCertificateDownloadField()} />
          <AppDetailInfoContentRow title="App catalog version" content={this.newAppData.version} />
          <AppDetailInfoContentRow title="Release date" content={utilsService.normalizeReleaseDate(this.newAppData.releaseDate, ' Upon Approval')} />
          <AppDetailInfoContentRow title="Short description" content={this.newAppData.shortDescription} />
          <AppDetailInfoContentRow title="Long description" content={this.newAppData.longDescription} />
          <AppDetailInfoContentRow title="Version notes" content={this.newAppData.versionNotes} />
          <AppDetailInfoContentRow title="Category" content={this.newAppMasterStore.getDisplayList('category')} />
          <AppDetailInfoContentRow title="Branch/Discipline" content={this.newAppMasterStore.getDisplayList('segments')} />
          <AppDetailInfoContentRow title="App capabilities" content={this.newAppMasterStore.getDisplayList('capabilities')} />
          <AppDetailInfoContentRow title="Certification" content={this.newAppMasterStore.getDisplayList('certifications')} />
          <AppDetailInfoContentRow title="Search keywords" content={this.newAppData.tags.toString().split(',').join(', ')} />
          <AppDetailInfoContentRow title="Developer company" content={this.newAppData.authorName} />
          <AppDetailInfoContentRow title="About the developer" content={this.newAppData.aboutDev} />
          <AppDetailInfoContentRow title="Developer website" content={this.newAppData.devWebsite} />
          <AppDetailInfoContentRow title="App package file" content={this.renderAppFileField()} />
          <AppDetailInfoContentRow title="Device" content={this.newAppDetailsStore.deviceAsHumanReadable} />
          {this.renderAppIcon()}
          {mobileScreenshots.length > 0 && this.renderScreenShots('phone', mobileScreenshots)}
          {tabletScreenshots.length > 0 && this.renderScreenShots('tablet', tabletScreenshots)}
        </section>
      </div>
    </div>);
  }
}
